"use client"
import { useState } from 'react'
import { useRouter } from 'next/navigation'

export default function PasswordPage() {
  try{
    if (typeof window !== 'undefined' && location.href.toLocaleLowerCase().includes("/password")) {
      (document as any).querySelector(".header")!.style.display = "none";
      (document as any).querySelector(".footer")!.style.display = "none";
      setTimeout(() => {
        document.querySelector(".header")?.remove();
        document.querySelector(".footer")?.remove();
      }, 1000);
    }
  }catch(ex){console.log(ex)}
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const router = useRouter()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    const res = await fetch('/api/auth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    })

    if (res.ok) {
      location.replace("/")
    } else {
      setError('Incorrect password')
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f5f5',
      backgroundImage: "url('/images/password-bg.webp')",
      backgroundSize: 'cover',
      backgroundPosition: 'center bottom'
    }}>
      <form onSubmit={handleSubmit} style={{
        padding: '2rem',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '300px'
      }}>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
          style={{ padding: '0.5rem', fontSize: '1rem' }}
        />
        <button type="submit" style={{
          padding: '0.5rem',
          fontSize: '1rem',
          backgroundColor: '#0070f3',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
          Enter
        </button>
        {error && <p style={{ color: 'red', margin: 0 }}>{error}</p>}
      </form>
    </div>
  )
}